import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Pagination({ pagination, onPageChange }) {
  const { page, limit, total, pages } = pagination;
  
  if (pages <= 1) return null;
  
  const goToPage = (newPage) => {
    if (newPage >= 1 && newPage <= pages) {
      onPageChange(newPage);
    }
  };
  
  // Calculate visible page numbers
  const getVisiblePages = () => {
    const visible = [];
    const maxVisible = 5;
    
    if (pages <= maxVisible) {
      for (let i = 1; i <= pages; i++) visible.push(i);
    } else if (page <= 3) {
      for (let i = 1; i <= maxVisible; i++) visible.push(i);
    } else if (page >= pages - 2) {
      for (let i = pages - maxVisible + 1; i <= pages; i++) visible.push(i);
    } else {
      for (let i = page - 2; i <= page + 2; i++) visible.push(i);
    }
    
    return visible;
  };
  
  const start = ((page - 1) * limit) + 1;
  const end = Math.min(page * limit, total);
  
  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-slate-200 bg-slate-50">
      <div className="text-sm text-slate-600">
        Showing {start.toLocaleString()} to {end.toLocaleString()} of {total.toLocaleString()} items
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => goToPage(page - 1)}
          disabled={page === 1}
          className="p-2 border border-slate-300 rounded-lg hover:bg-white disabled:opacity-50 disabled:cursor-not-allowed"
          data-testid="pagination-prev"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>
        
        <div className="flex gap-1">
          {getVisiblePages().map((pageNum) => (
            <button
              key={pageNum}
              onClick={() => goToPage(pageNum)}
              className={`w-8 h-8 rounded-lg text-sm ${
                page === pageNum
                  ? 'bg-indigo-600 text-white'
                  : 'border border-slate-300 hover:bg-white'
              }`}
              data-testid={`pagination-page-${pageNum}`}
            >
              {pageNum}
            </button>
          ))}
        </div>
        
        <button
          onClick={() => goToPage(page + 1)}
          disabled={page === pages}
          className="p-2 border border-slate-300 rounded-lg hover:bg-white disabled:opacity-50 disabled:cursor-not-allowed"
          data-testid="pagination-next"
        >
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
